import styled from '@emotion/styled';
import {Chip, CommandBar, Dialog} from '@bosch/react-frok';

export const DialogWrapper = styled(Dialog, {
    shouldForwardProp: (props) => props !== 'headlineSpace'
})<{ headlineSpace: boolean }>`
    & .m-dialog__headline {
        margin-right: ${(props) => (props.headlineSpace ? '8rem' : 0)};
        word-wrap: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const Description = styled.p`
    word-wrap: break-word;
    margin: 0;
`;

export const InfoText = styled.div`
    justify-content: center;
    align-self: center;
    text-align: center;
    width: max-content;
`;

export const BottomInfoBar = styled(InfoText)`
    display: flex;
    margin-top: 20px;
    gap: 2rem;
`;

export const BottomInfoElement = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const ContentWrapper = styled.div`
    flex-wrap: wrap;
`;

export const TagWrapper = styled(ContentWrapper)`
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

export const Tags = styled(StyledChipClickableArea)`
    justify-content: center;
    background-color: lightgrey;
    border: none;
    border-radius: 30px;
    font-size: small;
    text-align: center;
    align-self: center;
    width: max-content;
`;

export const ActionBar = styled(CommandBar)`
    margin-top: -4rem;
    background-color: white;

    &&& {
        padding: 0px;
    }
`;
